import { CheckOutlined } from '@ant-design/icons';
import { Select as AntdSelect } from 'antd';
import { nanoid } from 'nanoid';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { type Brightness, type SelectProps } from '../context';
import SelectContainer, { PorscheSelectCss, StyledPorscheArrow } from './Fields/shared';

const PorscheSelect = styled(AntdSelect)<Brightness>`
    ${PorscheSelectCss}
`;

const Select = ({ options, brightness = 'light', onChange, ...props }: SelectProps) => {
    const [value, setValue] = useState<string>();

    const handleChange = (newValue: string) => {
        setValue(newValue);
    };

    const updatedOptions = useMemo(
        () =>
            (options || []).map(option => ({
                ...option,
                selectLabel: option.label,
                label: (
                    <>
                        {option.label} {value === option.value ? <CheckOutlined role="img" /> : null}
                    </>
                ),
            })),
        [value, options]
    );

    const id = useMemo(() => nanoid(), []);

    return (
        <SelectContainer brightness={brightness} id={id}>
            <PorscheSelect
                {...props}
                brightness={brightness}
                getPopupContainer={() => document.getElementById(id)}
                onChange={handleChange}
                options={updatedOptions}
                suffixIcon={<StyledPorscheArrow />}
                showArrow
            />
        </SelectContainer>
    );
};

export default Select;
